import React from 'react';

interface HoldingItem {
  name: string;
  percentage: number;
  color: string;
}

interface HoldingsCardProps {
  title: string;
  holdings: HoldingItem[];
}

const HoldingsCard: React.FC<HoldingsCardProps> = ({ title, holdings }) => {
  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center gap-2">
        <span className="text-xs font-semibold text-[#1F1F1F]">{title}</span>
      </div>
      <div className="flex flex-col gap-1">
        {holdings.map((holding, index) => (
          <div key={index} className="flex min-h-[20px] items-center justify-between gap-3">
            <span className="w-12 text-xs text-gray-900">{holding.name}</span>
            <div className="flex items-center gap-1">
              <div className="h-1 w-16 rounded-full bg-gray-200">
                <div
                  className="h-1 rounded-full"
                  style={{
                    width: `${holding.percentage}%`,
                    backgroundColor: holding.color
                  }}
                />
              </div>
              <span className="text-xs text-gray-900">{holding.percentage}%</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HoldingsCard;
